import styled from 'styled-components';

export const Container = styled.div`
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.5) 0%, rgba(255, 255, 255, 0) 100%), rgba(234, 244, 252, 0.7);
  backdrop-filter: blur(100px);
  min-height: 100vh;
`;

export const StyledH2 = styled.h2`
  text-align: center;
`;
